import { Namespace } from '../../../../types/namespace';
import { Folder } from '../../../../util/Types/Folder';
import { FluxObject } from '../AgentsSidebar/context';
import { stampFlow } from '../AgentsSidebar/folderStructure';

const groupByFolderId = <T extends { folderId?: string | null }>(
  items: T[],
): Map<string, T[]> => {
  const map = new Map<string, T[]>();
  for (const item of items) {
    if (item.folderId == null) continue;
    const list = map.get(item.folderId);
    if (list) list.push(item);
    else map.set(item.folderId, [item]);
  }
  return map;
};

export const enrichFoldersWithItems = (
  folders: Folder[],
  objects: FluxObject[],
  namespaces: Namespace[],
  spaceId: string | null,
): Folder[] => {
  const annotateNs = (ns: Namespace): Namespace => ({
    ...ns,
    spaceId: ns.spaceId ?? spaceId,
  });
  const annotateObj = (obj: FluxObject): FluxObject => ({
    ...obj,
    spaceId: obj.spaceId ?? spaceId,
  });
  const objectsByFolder = groupByFolderId(objects);
  const namespacesByFolder = groupByFolderId(namespaces);

  const visit = (folder: Folder): Folder => ({
    ...folder,
    flows: (folder.flows ?? []).map(flow => stampFlow(flow, folder)),
    objects: (objectsByFolder.get(folder.id) ?? []).map(annotateObj),
    namespaces: (namespacesByFolder.get(folder.id) ?? []).map(annotateNs),
    folders: (folder.folders ?? []).map(visit),
  });

  return folders.map(visit);
};
